import { Button, Col, Typography, Row, Transfer, Space, notification } from 'antd';
import { TransferDirection } from 'antd/lib/transfer';
import React, { useState } from 'react';
import {
  useGetEligibleVehiclesQuery,
  useUpdateAuctionVehiclesMutation,
} from '../../../app/api/auctionApiSlice';
import AuctionVehicles from '../../../core/models/AuctionVehicles';
import Vehicle from '../../../core/models/Vehicle';

const { Text } = Typography;

interface IProps {
  auctionId: string;
  addedVehicles: Vehicle[];
  onSaveSuccess: () => void;
}

const AddVehicles: React.FC<IProps> = ({ auctionId, addedVehicles, onSaveSuccess }) => {
  const initialTargetKeys = addedVehicles.map((item) => item.id);

  const [targetKeys, setTargetKeys] = useState<string[]>(initialTargetKeys);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const { data: eligibleVehicles } = useGetEligibleVehiclesQuery();
  const [updateAuctionVehicles, { isLoading: isUpdatingVehicles }] =
    useUpdateAuctionVehiclesMutation();

  const onChange = (
    nextTargetKeys: string[],
    direction: TransferDirection,
    moveKeys: string[],
  ): void => {
    setTargetKeys(nextTargetKeys);
  };

  const onSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]): void => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const handleSave = (): void => {
    const auctionVehicles: AuctionVehicles = {
      auctionId: auctionId,
      vehicleList: targetKeys.map((key, index) => ({ vehicleId: key, lotNumber: index })),
    };

    updateAuctionVehicles(auctionVehicles)
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Success',
          description: 'Vehicles list updated',
        });
        onSaveSuccess();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Row gutter={[16, 24]}>
        <Col span={24}>
          <Button type='primary' onClick={() => handleSave()} loading={isUpdatingVehicles}>
            Save
          </Button>
        </Col>
        <Col>
          <Transfer
            dataSource={addedVehicles?.concat(eligibleVehicles ?? [])?.map((vehicle) => ({
              key: vehicle.id,
              title: `${vehicle.name} (${vehicle.plateNumber})`,
              description:
                vehicle.seller?.companyName ?? vehicle.seller?.personInCharge ?? 'Unknown',
            }))}
            titles={['Action Ready', 'In Auction']}
            listStyle={{
              width: '350px',
              height: '500px',
            }}
            targetKeys={targetKeys}
            selectedKeys={selectedKeys}
            onChange={onChange}
            onSelectChange={onSelectChange}
            render={(item) => {
              return (
                <Space direction='vertical' size={1}>
                  <Text strong>{item.title}</Text>
                  <Text>{item.description}</Text>
                </Space>
              );
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default AddVehicles;
